<template>
    <div class="ifs012">
        <ShareInfoBoardManageHeader/>

        <div class="ifs_cnt">
            <div class="tb-list_ty1">
                <div class="tb-header clear">
                    <div class="tb_num fl">
                        <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
                        <!-- 검색 조회시 노출 S -->
                        <div class="check_result" v-show="showSearchPaperTitle">
                            <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchPaperTitle, cnt: totalElements} )"></div>
                            <button type="button" @click="clearSearchPaperTitle">초기화</button>
                        </div>
                        <!-- //검색 조회시 노출 E -->
                    </div> 

                    <div class="tb_sort fr">
                        <input type="checkbox" name="" id="chkBookmarkFilter" v-model="filterBookMark" @change="bookmarkFilter"> <!-- filterBookMark bookmarkFilter -->
                        <label for="chkBookmarkFilter">{{ $i18nUtil.trans("button.favorite","즐겨찾기 보기") }}</label>
                        <div class="dividing_line_ty1"></div>
                        <div class="search_ty2">
                            <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                            <form action="" onsubmit="return false;" class="search-show">
                            <div class="input-box">
                                <input type="text" 
                                    class="search-show" 
                                    :class="searchPaperTitle == '' ? 'ico_search' : ''" 
                                    :placeholder="$i18nUtil.trans('message.ShareInfoBoardManage.001','보드명 검색')" 
                                    @focus="$event.target.placeholder=''"
                                    @focusout="$event.target.placeholder=$i18nUtil.trans('message.ShareInfoBoardManage.001','보드명 검색')"
                                    maxlength="21"
                                    v-model="searchPaperTitle" 
                                    @keyup.enter="getSearchBoardList()"
                                />
                                <button type="reset" 
                                    class="input-txt-del search-show" 
                                    @click="searchPaperTitle = ''" 
                                    v-if="searchPaperTitle != ''"
                                >
                                    입력 삭제
                                </button>
                                <button type="reset" 
                                    class="btn_search search-show" 
                                    @click="getSearchBoardList()"
                                >
                                    검색
                                </button>
                            </div>
                            </form>
                        </div>
                        <CommonFilterD 
                            :categoryList="categoryList"
                            :secretYn="true"
                            :initFilter="initFilter"
                            @updateCommonFilterD="updateCommonFilterD"/>
                    </div>
                </div>

                <v-data-table   
                    v-model="selected"
                    :headers="headers"
                    :items="boardListFilter"  
                    :page.sync="page"
                    :must-sort="true"
                    :items-per-page="itemsPerPage"
                    :server-items-length="totalElements"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @page-count="pageCount = $event"
                    hide-default-footer
                    class="tb-contents">

                    <template v-slot:[`item.categoryInfo.categoryName`]="{ item }">
                        <div class="d-block ell-singleline"
                            @mouseover="mouseEvt(true, item, $event)"
                            @mouseleave="mouseEvt(false, item, null)"
                        >
                            {{ item.categoryInfo.categoryName }}
                            <div class="tooltip-b tl small" style="display: none; position: absolute; z-index:11;" :id="item.paperId+'_'+item.categoryInfo.categoryMid+'_tooptip'">
                                {{ item.categoryInfo.categoryName }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.paperTitle`]="{ item }">
                        <div class="subject ell-singleline" @click="moveBoard(item)">
                            {{ item.paperTitle }}
                            <span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
                        </div>
                    </template>

                    <template v-slot:[`item.lastUpdUserName`]="{ item }">
                        <div class="droplayer tooltipmember relative right">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on">
                                        <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastUpdUserName : item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</b>
                                    </v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <UserTooltip
                                      :userId="item.lastUpdUserId"
                                    />
                                </div>
                            </v-menu>
                        </div>
                    </template> 

                    <template v-slot:[`item.regDate`]="{ item }"> 
                       {{$moment(item.regDate).format('YYYY.MM.DD') }}
                    </template>

                    <template v-slot:[`item.paperBookmarkId`]="{ item }" >  
                        <button type="button" class="ico-switch_favorites small" 
                                :class="item.paperBookmarkId != null ?'active':''"
                                @click="toggleBookmark($event, item)"  >  
                            즐겨찾기
                        </button>
                    </template>

                    <template v-slot:[`item.docGrade`]="{ item }" > 
                       {{
                            item.categoryInfo.docGrade =="NORMAL" || item.categoryInfo.docGrade == null
                            ? $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")
                            : item.docGrade == "NORMAL" || item.docGrade == null 
                                ? $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")
                                : item.docGrade == "RESTRICT"
                                    ? $i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")
                                    : $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")
                        }} 
                    </template> 
  
                    <template v-slot:[`item.paperLookupCount`]="{ item }" > 
                       {{item.paperLookupCount == null ? 0 : item.paperLookupCount > 999 ? '999+' :item.paperLookupCount }}  
                    </template> 

                    <template slot="no-data">
                        <div class="nodata-txt-noicon" v-if="boardListFilter.length == 0 && boardList.length != 0">
                            <v-alert :value="true">
                                {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                            </v-alert>
                        </div>
                        <div class="nodata-txt-noicon" v-if="boardListFilter.length == 0 && showSearchPaperTitle">
                            <v-alert :value="true">
                                {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                            </v-alert>
                        </div>
                        <div class="nodata-txt-noicon" v-if="boardList.length == 0 && !showSearchPaperTitle">
                            <v-alert :value="true">
                                {{ $i18nUtil.trans("search.017","생성된 정보 보드가 없습니다.") }}
                            </v-alert>
                        </div>
                    </template>

                    <template v-slot:[`item.more`]="{ item }">
                        <div class="droplayer icon more right nosel">
                            <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <div class="dropdown-list-item">
                                        <div class="tit">
                                            <button type="button"  @click="deleteBoard(item)" >{{ $i18nUtil.trans("button.paper.sharDelete","보드 삭제") }}</button>
                                        </div>
                                    </div>
                                </div>
                            </v-menu>
                        </div> 
                    </template>

                </v-data-table>

                <div class="pagination">
                    <v-pagination
                    v-model="page"
                    circle
                    :length="pageCount"
                    :total-visible="7"
                    ></v-pagination>
                </div>
            </div><!-- //tb-list_ty1 -->
        </div>
        <modals-container
            @board_Regist="addBoard"
        ></modals-container>
    </div><!-- //ifs004 -->
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import axios from "axios";
import Vue from "vue";
import ShareInfoBoardManageHeader from "./components/ShareInfoBoardManageHeader";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import CommonFilterD from "@/components/cowork/common/filter/CommonFilterD";
export default {
    components: {
        ShareInfoBoardManageHeader,
        UserTooltip,
        CommonFilterD
    },
    data() {
        return {
            headers: [
                { text: this.$i18nUtil.trans("entity.paper.filter.category","카테고리"), align: 'center', value: 'categoryInfo.categoryName', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.sharPaperTitle","보드명"), value: 'paperTitle',sortable: true },
                { text: this.$i18nUtil.trans("entity.paper.filter.docGrade","공개여부"), align: 'center', value: 'docGrade', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.lookup","조회수"), align: 'center', value: 'paperLookupCount', sortable: true },
                { text: this.$i18nUtil.trans("entity.paper.filter.regDate","생성일"), align: 'center', value: 'regDate', sortable: true },
                { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), align: 'center', value: 'lastUpdUserName', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), align: 'center', value: 'paperBookmarkId', sortable: false},
                { text: this.$i18nUtil.trans("entity.paper.filter.more","더보기"), align: 'center', value: 'more', sortable: false },
            ],
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
             
            firstConnect:true,
    
            page: 1,
            pageCount: 0,
            itemsPerPage: 20,
            selected: [],

            boardList:[],
            boardListFilter:[],

            filterBookMark:false,

            rtnSearchPaperTitle:'',
            showSearchPaperTitle:false,
            searchPaperTitle:'',
            isSearchArea:false,

            /* 정렬 */
            totalElements: 0,
            sortBy: 'regDate',
            sortDesc: true,

            /* 페이지 변경 또는 정렬 이벤트시 */
            changeTableData: false,

            isSearch:false,
            categoryList : [],
            statusCodeList:[],
            gradeCodeList : [],
            categoryMidCodeList :[],

            initFilter:{},
            backDataSet:true,

            categoryCheckYn : false,
            gradeCheckYn : false,

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        };
    },
    created(){ 
        // sessionStorage 값으로 셋팅.
        if(window.sessionStorage.getItem("shareInfoBoardManage") != null){
            let sessionStorage = JSON.parse(window.sessionStorage.getItem("shareInfoBoardManage"));
            this.backDataSet = false;
            this.page = sessionStorage.page;
            this.filterBookMark = sessionStorage.filterBookMark;
            this.sortBy = sessionStorage.sortBy;
            this.sortDesc = sessionStorage.sortDesc; 
            this.gradeCodeList = sessionStorage.gradeCodeList;
            this.categoryMidCodeList = sessionStorage.categoryMidCodeList;
            this.categoryCheckYn = sessionStorage.categoryCheckYn;
            this.gradeCheckYn = sessionStorage.gradeCheckYn;

            if(sessionStorage.searchPaperTitle != ''){
                this.searchPaperTitle = sessionStorage.searchPaperTitle;
                this.isSearchArea = true;
            }
            window.sessionStorage.removeItem("shareInfoBoardManage");
        }
    },
    mounted() {
      const self = this;
      $("html").click(function (e) {
        if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
            self.isSearchArea = false;
        }
      });
      this.getBoardList(false);

        // 뒤로가기 이벤트 발생시 .
        window.onpopstate = function (event) {
            let returnUrls = localStorage.getItem("returnUrls");
            if(returnUrls != null) {
                let urlList = returnUrls.split(",");
                if (urlList.length > 0) {
                    if (urlList.length == 1) {
                        localStorage.removeItem("returnUrls");
                        // self.$router.push("/general/home");
                    } else {
                        urlList.pop();
                        localStorage.setItem("returnUrls", urlList);
                        // this.$router.replace(urlList[urlList.length-1]);
                    }
                } else {
                    self.$router.push("/general/home");
                }
            }else{
                self.$router.push("/general/home");
            }
        }
    },
    watch:{
        page:{
            handler() {
                if(this.changeTableData != true){
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        sortBy: {
            handler() { 
                if(this.changeTableData != true){ 
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        sortDesc: {
            handler() { 
                if(this.changeTableData != true){ 
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        changeTableData:{
            handler(){
                let obj = this;
                if(obj.changeTableData == true && obj.backDataSet == true){
                    setTimeout(() => {
                        obj.changeTableData = false;
                        // obj.boardListFilter = [];
                        // obj.boardList = [];
                        obj.getBoardList(this.isSearch);
                    }, 500);
                }

                if(obj.backDataSet == false){
                    obj.changeTableData =false;
                }
            },
            deep: true
        },
    }, 
    methods: { 
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
        ...mapActions("modals", ["showToast", "showModal"]), 

        /* 툴팁 */
        mouseEvt(flag, item, event) {
            let tooptipId = item.paperId+'_'+item.categoryInfo.categoryMid+'_tooptip';
            if(flag) {
            // 말줄임(...) css 적용 여부 체크 (boolean)
                let val = this.$tooltip.hasOverflownHeightRemoveClass(event.target, "ell-singleline");
                if(val) {
                    document.getElementById(tooptipId).style.display = 'block';
                }else{
                    document.getElementById(tooptipId).style.display = 'none';
                };
            }else{
                document.getElementById(tooptipId).style.display = 'none';
            }
        },
        getBoardList(isSearch){
            let obj = this;
            if(isSearch == true) {
                if(obj.searchPaperTitle == '') {
                    obj.toastInfo.message = obj.$i18nUtil.trans("TB091");//;
                    obj.showToast(obj.toastInfo);
                    return;
                }
            }

            obj.boardListFilter = [];
            obj.boardList = [];

            if(obj.searchPaperTitle != null && obj.searchPaperTitle != undefined && obj.searchPaperTitle.length > 0) {
                obj.showSearchPaperTitle = true;
            } else {
                obj.showSearchPaperTitle = false;
            }

            obj.rtnSearchPaperTitle= obj.searchPaperTitle;
            
            let reqData = {};
            reqData.params ={
                page : obj.page-1,
                itemsPerPage : obj.itemsPerPage,
                filterBookMark : obj.filterBookMark ? 1 : 0,
                sortKey: obj.sortBy,
                sortDesc: obj.sortDesc,
                searchPaperTitle : "%"+obj.searchPaperTitle+"%",
                gradeCodeList : obj.gradeCodeList,
                categoryMidCodeList : obj.categoryMidCodeList,
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/getShareInfoBoardListPaging";
            reqData.method = "post";
            //프로그레스바 시작 
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {  
                    //프로그레스바 종료
                    this.hideLoadingbar();   
                    this.boardList=res.result.paperList.content;
                    this.boardListFilter=res.result.paperList.content;
                    this.totalElements = res.result.paperList.totalElements;
                    this.pageCount = res.result.paperList.totalPages; 
                    this.categoryList = res.result.categoryList;

                    this.backDataSet = true;
                    this.initFilter = {
                        gradeCodeList : this.gradeCheckYn == true ? this.gradeCodeList : [],
                        categoryMidCodeList : this.categoryCheckYn == true ? this.categoryMidCodeList : []
                    }

                    // 보드 상세정보 가져오는 API
                    this.getPaperInfoDetail();

                    obj.$nextTick(function(){ 
                        obj.firstConnect = false;
                    });  
                })
                .catch(function(err) {
                    console.log(err);
                }); 
        },
        getPaperInfoDetail(){ 
            let paperIdList =[];
            this.boardList.forEach(function(item){
                paperIdList.push(item.paperId);
            })
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperIdList : paperIdList
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/getPaperInfoDetail";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => { 
                for(let k in obj.boardList){  
                    obj.boardList[k].paperLikeYN = res.result.paperInfoList[k].paperLike;
                    obj.boardList[k].paperLikeCount = res.result.paperInfoList[k].paperLikeCount;
                    if(res.result.paperInfoList[k].paperBookmark != null){
                        obj.boardList[k].paperBookmarkId = res.result.paperInfoList[k].paperBookmark.paperBookmarkId;
                    }
                } 
            })
            .catch(function(err) {
                console.log(err);
            });
      
        },
        addBoard(_data){ 
            let obj = this;
            let reqData = {};
            reqData.params = {
                paperTitle: _data.boardName,
                paperId: _data.paperId,
                groupId: _data.category.groupId,
                categoryMid: _data.category.categoryMid,
                contentPath: _data.contentPath, 
                docGrade:  _data.docGrade,
                blockType: "CONTENT",
                postYn: "1",
                link: "/general/board/" + _data.paperId,
            };
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/addPaper";
            reqData.method = "post";
            //프로그레스바 시작 
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => { 
                    //프로그레스바 종료
                    this.hideLoadingbar(); 
                    if(res.errorCode != null){
                        if (res.errorCode == "NOT_AUTHORIZED"){
                            this.showToast(this.toastInfo);
                            this.toastInfo.message =  this.$i18nUtil.trans('TB044');
                        }
                    }else{
                        this.toastInfo.message = this.$i18nUtil.trans("TB036.002");
                        this.showToast(this.toastInfo);
                        let newBoard = res.result;
                        this.$router.push("/general/board/" + newBoard);
                    } 
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        /* 보드 삭제  */
        deleteBoard(item){
            let obj = this;
            obj.showConfirmDialog(
                { width:"400px" },
                obj.$i18nUtil.trans("title.dialog.notice","알림"), obj.$i18nUtil.trans("AB001.002"),
                obj.$i18nUtil.trans("button.dialog.delete","삭제"), obj.deletePaperApiCall,
                { item: item }, obj.$i18nUtil.trans("button.dialog.cancel","취소"), null
            );
        },
        deletePaperApiCall(callbackData) {
            let obj = this;
            let reqData = {};
            reqData.params = {
                paperId : callbackData.modalParam.item.paperId,
                groupId : callbackData.modalParam.item.groupId,
                categoryMid : callbackData.modalParam.item.categoryMid,  
            };  
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/deletePaper";
            reqData.method = "post";
            //프로그레스바 시작 
            obj.showLoadingbar();
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
                //프로그레스바 종료
                obj.hideLoadingbar();
                if(res.fncAuthRst != null) {
                    // 삭제 권한이 없을 경우
                    if(!res.fncAuthRst.allow) {
                        obj.toastInfo.message = obj.$i18nUtil.trans('TB056');
                        obj.showToast(obj.toastInfo);
                        return;
                    }
                }
                this.toastInfo.message = this.$i18nUtil.trans('TB027.002');
                this.showToast(this.toastInfo); 
                this.searchPaperTitle = '';
                this.rtnSearchPaperTitle = '';
                this.showSearchPaperTitle = false;
                this.getBoardList(false);
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        moveBoard(item){
            //뒤로가기
            let state ={
                page : this.page,
                searchPaperTitle : this.searchPaperTitle,
                filterBookMark : this.filterBookMark,
                sortBy : this.sortBy,
                sortDesc : this.sortDesc,
                gradeCodeList : this.gradeCodeList,
                categoryMidCodeList : this.categoryMidCodeList,
                categoryCheckYn : this.categoryCheckYn,
                gradeCheckYn : this.gradeCheckYn
            };
            window.sessionStorage.setItem("shareInfoBoardManage",JSON.stringify(state));
            // history.pushState(state, document.title, location.href);  
            let path = "/general/board/" + item.paperId;
            this.$router.push(path);
        }, 
        toggleBookmark(event, item) {
            event.target.classList.toggle("active");
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperId: item.paperId,
                bookmarkId: item.paperBookmarkId
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/bookmark/savePaperBookmark";
            reqData.method = "post";
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {   
                    obj.boardList.forEach(function(board){
                        if(board.paperId == item.paperId){
                            board.paperBookmarkId = res.result;
                        }
                    }) 
                    if(res.result == null){
                        //즐겨찾기 해제
                        this.toastInfo.message = this.$i18nUtil.trans("TB042");
                        this.showToast(this.toastInfo); 
                    }else{
                        //즐겨찾기   
                        this.toastInfo.message = this.$i18nUtil.trans("TB041");
                        this.showToast(this.toastInfo); 
                    }
                }) 
                .catch(function(err) {
                console.log(err);
                }); 
        },
        bookmarkFilter(){ 
            let obj = this;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        clearSearchPaperTitle(){
            let obj =this;
            obj.page = 1;
            obj.isSearch = false;
            obj.boardListFilter = [];
            obj.boardList = [];
            obj.searchPaperTitle = '';
            obj.rtnSearchPaperTitle = '';
            obj.showSearchPaperTitle = false;
            obj.getBoardList(false);
        },
        getSearchBoardList(){
            this.isSearch = true;
            let obj = this;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        updateCommonFilterD(filterData){
            let obj = this;
            obj.categoryMidCodeList = filterData.filterCategoryList;
            obj.gradeCodeList = filterData.filterGradeList;
            obj.categoryCheckYn = filterData.categoryCheckYn;
            obj.gradeCheckYn = filterData.gradeCheckYn;

            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
    }
};
</script> 


// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/manage/ShareInfoBoardManage.vue